<template>
  <div>
    <ProjectCardList
      :projects="$store.state.ProjectStore.projects"
    ></ProjectCardList>
  </div>
</template>

<script>
//import ProjectModel from '../models/ProjectModel'
import ProjectCardList from '../components/ProjectCardList'

export default {
  components: {
    ProjectCardList
  },
  data() {
    return {
      name: 'Dummy Project Name'
    }
  },
  created: function() {
    this.$store.dispatch('ProjectStore/fetchProjects')
  },
  methods: {}
}
</script>

<style scoped></style>
